import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CRUDs from '../../../../api/CRUDs';
import { useMRTState } from '../../../../hooks/useMRTState';
import { useNavigateParams } from '../../../../hooks/useNavigateParams';
import { useActionLock } from '../../../../hooks/useActionLock';
import useFlashMessage from '../../../../hooks/useFlashMessage';

export function useListagemModule({ parametro, permissoes }) {
    const mrt = useMRTState({ storageKey: 'Eleicao.Index', pageSizeDefault: Math.min(Number(parametro?.paginacao) || 5, 200) });
    const { columnFilters, columnFilterFns, globalFilter, sorting, pagination, setRowCount, setIsLoading, setIsRefetching, setIsError } = mrt;
    const [dados, setDados] = useState([]);
    const [selecionada, setSelecionada] = useState(null);
    const request = useRef(0), carregou = useRef(false);
    const empresaId = localStorage.getItem('empresaId');
    const lock = useActionLock();
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const location = useLocation();
    const carregar = useCallback(async () => {
        const atual = ++request.current;
        setIsLoading(!carregou.current); setIsRefetching(carregou.current);
        try {
            const { data } = await CRUDs.eleicao.listar(pagination.pageIndex * pagination.pageSize, pagination.pageSize,
                JSON.stringify(columnFilters), JSON.stringify(columnFilterFns), globalFilter, JSON.stringify(sorting));
            if (atual !== request.current) return;
            setDados(data.data); setRowCount(data.meta.totalRowCount); setIsError(false); carregou.current = true;
        } catch (e) { if (atual === request.current) setIsError(true); }
        finally { if (atual === request.current) { setIsLoading(false); setIsRefetching(false); } }
    }, [pagination.pageIndex, pagination.pageSize, columnFilters, columnFilterFns, globalFilter, sorting, setRowCount, setIsLoading, setIsRefetching, setIsError]);
    useEffect(() => {
        if (permissoes.autorizado) carregar();
        return () => { request.current += 1; };
    }, [permissoes.autorizado, empresaId, carregar]);
    const abrir = (row) => {
        if (!(row ? permissoes.editar : permissoes.incluir)) return;
        const params = new URLSearchParams(location.search);
        if (row) params.set('uuid', row.uuid); else params.delete('uuid');
        params.set('btnText', row ? 'Atualizar' : 'Cadastrar');
        navigate('/Eleicao/CreateOrEdit', params);
    };
    const excluir = () => lock.run(async () => {
        if (!permissoes.cancelar || !selecionada) return;
        try {
            const { data } = await CRUDs.eleicao.deletar({ uuid: selecionada.uuid });
            setFlashMessage(data.message, data.type); setSelecionada(null);
            if (dados.length === 1 && pagination.pageIndex > 0) mrt.setPagination((prev) => ({ ...prev, pageIndex: prev.pageIndex - 1 }));
            else await carregar();
        } catch (e) { setFlashMessage(e.response?.data?.message || 'Erro ao excluir eleição.', 'error'); }
    });
    return { mrt, dados, selecionada, setSelecionada, abrir, excluir, excluindo: lock.isLocked };
}
